// Dati dei tatuatori e coefficienti
const tatuatoriData = {
    martina: {
        nome: "Martina Gaudio",
        coefficiente: 2.62,
        stili: {
            chicano: { nome: "Chicano", coefficiente: 1 },
            realistico: { nome: "Realistico /Black n' Gray", coefficiente: 1.1 },
            dotwork: { nome: "DotWork", coefficiente: 0.85 },
            lettering: { nome: "Lettering", coefficiente: 0.75 },
            maori: { nome: "Maori", coefficiente: 1.5 },
            geometrico: { nome: "Geometrico", coefficiente: 1.5 },
            trashpolka: { nome: "TrashPolka", coefficiente: 0.9 },
            minimale: { nome: "Minimale", coefficiente: 0.72 },
            blackwork: { nome: "BlackWork", coefficiente: 1.12 }
        }
    },
    brian: {
        nome: "Brian Capurso",
        coefficiente: 2.2,
        stili: {
            lettering: { nome: "Lettering", coefficiente: 0.75 },
            blackngray: { nome: "Black n' Gray", coefficiente: 0.8 },
            geometrico: { nome: "Geometrico", coefficiente: 0.8 },
            maori: { nome: "Maori", coefficiente: 0.82 }
        }
    },
    greta: {
        nome: "Greta Colaneri",
        coefficiente: 2.12,
        stili: {
            minimale: { nome: "Minimale", coefficiente: 0.8 },
            blackwork: { nome: "BlackWork", coefficiente: 1.21 }
        }
    },
    alex: {
        nome: "Alex De Cia",
        coefficiente: 2.11,
        stili: {
            giapponese: { nome: "Giapponese", coefficiente: 1 },
            oldschool: { nome: "Old School", coefficiente: 0.75 },
            minimale: { nome: "Minimale", coefficiente: 0.65 }
        }
    }
};

// Coefficienti per colori e dettagli
const coloriCoefficienti = {
    biancoNero: 1,
    colorato: 1.05
};

const dettagliCoefficienti = {
    basico: 0.9,
    intermedio: 1,
    avanzato: 1.1
};

// Prezzo minimo
const PREZZO_MINIMO = 60;

// Elementi DOM
document.addEventListener('DOMContentLoaded', function() {
    const tatuatoreSelect = document.getElementById('tatuatore');
    const stileSelect = document.getElementById('stile');
    const biancoNeroRadio = document.getElementById('biancoNero');
    const coloratoRadio = document.getElementById('colorato');
    const altezzaSlider = document.getElementById('altezza');
    const larghezzaSlider = document.getElementById('larghezza');
    const altezzaValue = document.getElementById('altezza-value');
    const larghezzaValue = document.getElementById('larghezza-value');
    const dettaglioBasico = document.getElementById('dettaglio-basico');
    const dettaglioIntermedio = document.getElementById('dettaglio-intermedio');
    const dettaglioAvanzato = document.getElementById('dettaglio-avanzato');
    const detailProgressFill = document.getElementById('detail-progress-fill');
    const prezzoElement = document.getElementById('prezzo');

    // Funzione per popolare gli stili in base al tatuatore selezionato
    function popolaStili() {
        const tatuatoreSelezionato = tatuatoreSelect.value;
        const stili = tatuatoriData[tatuatoreSelezionato].stili;
        
        // Svuota il select degli stili
        stileSelect.innerHTML = '';
        
        // Popola il select con gli stili disponibili
        Object.keys(stili).forEach(stileKey => {
            const option = document.createElement('option');
            option.value = stileKey;
            option.textContent = stili[stileKey].nome;
            stileSelect.appendChild(option);
        });
        // Seleziona la prima opzione di default
        if (stileSelect.options.length > 0) {
            stileSelect.selectedIndex = 0;
        }
        
        // Calcola il prezzo dopo aver aggiornato gli stili
        calcolaPrezzo();
    }

    // Funzione per aggiornare la barra di progresso del dettaglio
    function aggiornaBarraDettaglio() {
        if (dettaglioBasico.checked) {
            detailProgressFill.style.width = '33.33%';
        } else if (dettaglioIntermedio.checked) {
            detailProgressFill.style.width = '66.66%';
        } else if (dettaglioAvanzato.checked) {
            detailProgressFill.style.width = '100%';
        }
    }

    // Funzione per calcolare il prezzo
    function calcolaPrezzo() {
        // Ottieni i valori selezionati
        const tatuatoreSelezionato = tatuatoreSelect.value;
        const stileSelezionato = stileSelect.value;
        const coloreSelezionato = biancoNeroRadio.checked ? 'biancoNero' : 'colorato';
        const altezza = parseInt(altezzaSlider.value);
        const larghezza = parseInt(larghezzaSlider.value);
        const dettaglioSelezionato = dettaglioBasico.checked ? 'basico' : (dettaglioIntermedio.checked ? 'intermedio' : 'avanzato');
        
        // Calcola l'area in cm²
        const area = altezza * larghezza;
        
        // Ottieni i coefficienti
        const coefficienteTatuatore = tatuatoriData[tatuatoreSelezionato].coefficiente;
        const coefficienteStile = tatuatoriData[tatuatoreSelezionato].stili[stileSelezionato].coefficiente;
        const coefficienteColore = coloriCoefficienti[coloreSelezionato];
        const coefficienteDettaglio = dettagliCoefficienti[dettaglioSelezionato];
        
        // Calcola il prezzo
        let prezzo = area * coefficienteTatuatore * coefficienteStile * coefficienteColore * coefficienteDettaglio;
        
        // Applica il prezzo minimo
        prezzo = Math.max(prezzo, PREZZO_MINIMO);
        
        // Arrotonda il prezzo all'intero più vicino
        prezzo = Math.round(prezzo);
        
        // Aggiorna l'elemento del prezzo con animazione
        animateValue(prezzoElement, parseInt(prezzoElement.textContent), prezzo, 500);
    }

    // Funzione per animare il cambio di valore del prezzo
    function animateValue(element, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const value = Math.floor(progress * (end - start) + start);
            element.textContent = value;
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    // Event listeners
    if (tatuatoreSelect) {
        tatuatoreSelect.addEventListener('change', popolaStili);
    }
    
    if (stileSelect) {
        stileSelect.addEventListener('change', calcolaPrezzo);
    }
    
    if (biancoNeroRadio) {
        biancoNeroRadio.addEventListener('change', calcolaPrezzo);
    }
    
    if (coloratoRadio) {
        coloratoRadio.addEventListener('change', calcolaPrezzo);
    }

    if (altezzaSlider) {
        altezzaSlider.addEventListener('input', function() {
            altezzaValue.textContent = this.value;
            calcolaPrezzo();
        });
    }

    if (larghezzaSlider) {
        larghezzaSlider.addEventListener('input', function() {
            larghezzaValue.textContent = this.value;
            calcolaPrezzo();
        });
    }

    if (dettaglioBasico) {
        dettaglioBasico.addEventListener('change', function() {
            if (this.checked) {
                aggiornaBarraDettaglio();
                calcolaPrezzo();
            }
        });
    }

    if (dettaglioIntermedio) {
        dettaglioIntermedio.addEventListener('change', function() {
            if (this.checked) {
                aggiornaBarraDettaglio();
                calcolaPrezzo();
            }
        });
    }

    if (dettaglioAvanzato) {
        dettaglioAvanzato.addEventListener('change', function() {
            if (this.checked) {
                aggiornaBarraDettaglio();
                calcolaPrezzo();
            }
        });
    }

    // Inizializzazione
    if (tatuatoreSelect && stileSelect && altezzaValue && larghezzaValue && detailProgressFill) {
        // Popola gli stili iniziali
        popolaStili();
        
        // Imposta i valori iniziali degli slider
        if (altezzaSlider) altezzaValue.textContent = altezzaSlider.value;
        if (larghezzaSlider) larghezzaValue.textContent = larghezzaSlider.value;
        
        // Imposta la barra di progresso del dettaglio
        aggiornaBarraDettaglio();
        
        // Calcola il prezzo iniziale
        calcolaPrezzo();
    }

    // Funzione per tooltip
    const tooltipIcons = document.querySelectorAll('.tooltip-icon');
    if (tooltipIcons.length > 0) {
        tooltipIcons.forEach(icon => {
            icon.addEventListener('mouseover', function() {
                const tooltip = document.createElement('div');
                tooltip.className = 'tooltip';
                tooltip.textContent = this.getAttribute('title');
                tooltip.style.position = 'absolute';
                
                document.body.appendChild(tooltip);
                
                const rect = this.getBoundingClientRect();
                tooltip.style.top = `${rect.bottom + window.scrollY + 5}px`;
                tooltip.style.left = `${rect.left + window.scrollX}px`;
                
                this.addEventListener('mouseout', function() {
                    document.body.removeChild(tooltip);
                }, { once: true });
            });
        });
    }

    // Effetti di parallasse e animazioni
    window.addEventListener('scroll', function() {
        const scrollPosition = window.scrollY;
        
        // Animazione per le sezioni al momento dello scroll
        const sections = document.querySelectorAll('.section');
        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top;
            const sectionBottom = section.getBoundingClientRect().bottom;
            
            if (sectionTop < window.innerHeight * 0.8 && sectionBottom > 0) {
                section.style.opacity = '1';
                section.style.transform = 'translateY(0)';
            }
        });
    });

    // Effetto hover sui pulsanti
    const buttons = document.querySelectorAll('.cta-button, .secondary-button');
    buttons.forEach(button => {
        button.addEventListener('mouseover', function() {
            this.style.transform = 'translateY(-5px)';
        });
        
        button.addEventListener('mouseout', function() {
            this.style.transform = '';
        });
    });

    // Effetto di transizione fluida per le immagini
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        img.addEventListener('load', function() {
            this.style.opacity = '1';
        });
    });
});

// Funzione per gestire il ridimensionamento della finestra
window.addEventListener('resize', function() {
    // Adatta l'interfaccia in base alla dimensione dello schermo
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
    
    // Adatta elementi specifici per mobile
    if (isMobile) {
        // Adattamenti specifici per mobile
        document.querySelectorAll('.section').forEach(section => {
            section.style.padding = '15px';
        });
    } else if (isTablet) {
        // Adattamenti specifici per tablet
        document.querySelectorAll('.section').forEach(section => {
            section.style.padding = '20px';
        });
    } else {
        // Adattamenti specifici per desktop
        document.querySelectorAll('.section').forEach(section => {
            section.style.padding = '30px';
        });
    }
});
